import React from 'react';
import style from '../../assets/scss/components/pages/MainPage.module.scss';
import { convertKeysToCamelCase } from '../../helpers/baseHelpers';
import { PrivacyPolicy } from '../settings-page/PrivacyPolicy';

export const PrivacyPolicyPage: React.FC = () => {
  const { wrapper, contentWrapper } = convertKeysToCamelCase(style);

  return (
    <div className={wrapper}>
      <div className={contentWrapper}>
        <PrivacyPolicy />
      </div>
    </div>
  );
};
